<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      :icon="icon"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t(name) }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @keydown.enter="getDataFromApi"
          @blur="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:body.prepend>
          <filter-row
            :filter-options="filterOptions"
            :headers="headers"
            :filter="filter"
            @set-filter="setFilter"
          />
        </template>
        <template v-slot:item.response_code="{ item }">
          <v-chip
            :color="(item.response_code <= 299 && item.response_code >= 200) ? 'green' : (item.response_code <= 399 && item.response_code >= 300) ? 'yellow' : 'red'"
            text-color="white"
          >
            {{ item.response_code }}
          </v-chip>
        </template>
        <template v-slot:item.route="{ item }">
          <span :title="item.route">
            {{ item.route | shorten }}
          </span>
        </template>
        <template v-slot:item.created_at="{item}">
          {{ convertUTCToLocal(item.created_at) }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              remove_red_eye
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import _ from 'lodash'

  export default {
    filters: {
      shorten: function (value) {
        if (!value) return ''
        value = value.toString()
        return _.truncate(value, { length: 150 })
      },
    },

    mixins: [List],
    data () {
      return {
        endpoint: 'logs/input',
        name: 'logs',
        icon: 'notes',
        headers: [
          {
            sortable: false,
            text: this.$t('id'),
            value: 'id',
          },
          {
            sortable: false,
            text: this.$t('http_code'),
            value: 'response_code',
          },
          {
            sortable: false,
            text: this.$t('method'),
            value: 'method',
          },
          {
            sortable: false,
            text: this.$t('route'),
            value: 'route',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('auth_id'),
            value: 'auth_id',
          },
          {
            text: this.$t('timestamp'),
            value: 'created_at',
            align: 'right',
          },
          { text: this.$t('actions'), align: 'right', value: 'action', sortable: false },
        ],
        filterOptions: {
          id: {
            label: this.$t('id'),
            type: 'range',
            filter: {},
          },
          auth_id: {
            label: this.$t('auth_id'),
            type: 'range',
            filter: {},
          },
          response_code: {
            label: this.$t('http_code'),
            type: 'free',
            filter: '',
          },
          route: {
            label: this.$t('route'),
            type: 'free',
            filter: '',
          },
          method: {
            label: this.$t('method'),
            type: 'multi',
            options: [
              { slug: 'post', label: 'POST' },
              { slug: 'put', label: 'PUT' },
              { slug: 'get', label: 'GET' },
              { slug: 'delete', label: 'DELETE' },
              { slug: 'patch', label: 'PATCH' },
            ],
            filter: [],
          },
          created_at: {
            label: this.$t('created'),
            type: 'date-range',
            filter: {},
          },
        },
      }
    },

    methods: {
      editItem: function ({ id }) {
        this.$router.push(`/logs/input/${id}`)
      },
    },
  }
</script>
